import React, { useState, useEffect } from 'react';
import '../styles/Pages.css';
import '../styles/Dividas.css';

export default function Dividas() {
  const [dividas, setDividas] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showCategorias, setShowCategorias] = useState(false);
  const [novaCategoria, setNovaCategoria] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [acaoAberta, setAcaoAberta] = useState(null); // { id, tipo: 'antecipar' | 'atualizar' | 'historico' }
  const [antecipacaoForm, setAntecipacaoForm] = useState({ num_parcelas: 1, desconto: '' });
  const [atualizarForm, setAtualizarForm] = useState({ valor: '', observacao: '' });
  const [historico, setHistorico] = useState([]);

  const [formData, setFormData] = useState({
    nome: '',
    tipo: 'divida',
    categoriaDividaId: '',
    valor: '',
    taxa_juros: '',
    prazo_meses: '',
    numero_processo: ''
  });

  useEffect(() => {
    carregarDividas();
    carregarCategorias();
  }, []);

  const carregarDividas = async () => {
    const token = localStorage.getItem('token');
    try {
      const res = await fetch('/api/dividas', { headers: { 'Authorization': `Bearer ${token}` } });
      const data = await res.json();
      setDividas(data.dividas || []);
    } catch (error) { console.error('Erro:', error); }
  };

  const carregarCategorias = async () => {
    const token = localStorage.getItem('token');
    try {
      const res = await fetch('/api/dividas/categorias', { headers: { 'Authorization': `Bearer ${token}` } });
      const data = await res.json();
      setCategorias(data.categorias || []);
    } catch (error) { console.error('Erro:', error); }
  };

  const handleAddCategoria = async (e) => {
    e.preventDefault();
    if (!novaCategoria.trim()) return;
    const token = localStorage.getItem('token');
    try {
      const res = await fetch('/api/dividas/categorias', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ nome: novaCategoria.trim() })
      });
      const data = await res.json();
      if (data.success) {
        setNovaCategoria('');
        carregarCategorias();
      }
    } catch (error) { console.error('Erro:', error); }
  };

  const handleDeletarCategoria = async (id) => {
    if (!window.confirm('Deletar esta categoria?')) return;
    const token = localStorage.getItem('token');
    try {
      const res = await fetch(`/api/dividas/categorias/${id}`, { method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` } });
      const data = await res.json();
      if (data.success) carregarCategorias();
    } catch (error) { console.error('Erro:', error); }
  };

  const handleAddOuEditar = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    const url = editingId ? `/api/dividas/${editingId}` : '/api/dividas';
    const method = editingId ? 'PUT' : 'POST';

    const dados = {
      nome: formData.nome,
      tipo: formData.tipo,
      categoriaDividaId: formData.categoriaDividaId ? parseInt(formData.categoriaDividaId) : null,
      valor: parseFloat(formData.valor),
      taxa_juros: formData.tipo === 'divida' ? parseFloat(formData.taxa_juros || 0) : 0,
      prazo_meses: formData.tipo === 'divida' && formData.prazo_meses ? parseInt(formData.prazo_meses) : null,
      numero_processo: formData.tipo === 'processo' ? formData.numero_processo : null
    };

    try {
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(dados)
      });
      const data = await res.json();
      if (data.success) {
        handleCancelar();
        carregarDividas();
      }
    } catch (error) { console.error('Erro:', error); }
  };

  const handleEditar = (divida) => {
    setFormData({
      nome: divida.nome,
      tipo: divida.tipo || 'divida',
      categoriaDividaId: divida.categoriaDividaId || '',
      valor: divida.valor,
      taxa_juros: divida.taxa_juros || '',
      prazo_meses: divida.prazo_meses || '',
      numero_processo: divida.numero_processo || ''
    });
    setEditingId(divida.id);
    setShowForm(true);
  };

  const handleDeletar = async (id) => {
    if (!window.confirm('Deletar?')) return;
    const token = localStorage.getItem('token');
    try {
      const res = await fetch(`/api/dividas/${id}`, { method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` } });
      const data = await res.json();
      if (data.success) carregarDividas();
    } catch (error) { console.error('Erro:', error); }
  };

  const handleCancelar = () => {
    setShowForm(false);
    setEditingId(null);
    setFormData({ nome: '', tipo: 'divida', categoriaDividaId: '', valor: '', taxa_juros: '', prazo_meses: '', numero_processo: '' });
  };

  const abrirAntecipar = (divida) => {
    setAcaoAberta({ id: divida.id, tipo: 'antecipar' });
    setAntecipacaoForm({ num_parcelas: 1, desconto: '' });
  };

  const abrirAtualizarValor = (divida) => {
    setAcaoAberta({ id: divida.id, tipo: 'atualizar' });
    setAtualizarForm({ valor: divida.valor, observacao: '' });
  };

  const abrirHistorico = async (divida) => {
    setAcaoAberta({ id: divida.id, tipo: 'historico' });
    const token = localStorage.getItem('token');
    try {
      const res = await fetch(`/api/dividas/${divida.id}/historico-valores`, { headers: { 'Authorization': `Bearer ${token}` } });
      const data = await res.json();
      setHistorico(data.historico || []);
    } catch (error) { console.error('Erro:', error); }
  };

  const handleConfirmarAntecipacao = async (dividaId) => {
    const token = localStorage.getItem('token');
    try {
      const res = await fetch(`/api/dividas/${dividaId}/antecipar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ num_parcelas: parseInt(antecipacaoForm.num_parcelas), desconto: parseFloat(antecipacaoForm.desconto || 0) })
      });
      const data = await res.json();
      if (data.success) {
        setAcaoAberta(null);
        carregarDividas();
      } else {
        alert(data.error || 'Erro ao antecipar');
      }
    } catch (error) { console.error('Erro:', error); }
  };

  const handleConfirmarAtualizacao = async (dividaId) => {
    const token = localStorage.getItem('token');
    try {
      const res = await fetch(`/api/dividas/${dividaId}/atualizar-valor`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ valor: parseFloat(atualizarForm.valor), observacao: atualizarForm.observacao })
      });
      const data = await res.json();
      if (data.success) {
        setAcaoAberta(null);
        carregarDividas();
      }
    } catch (error) { console.error('Erro:', error); }
  };

  return (
    <div className="page">
      <h1>💳 Dívidas e Processos</h1>

      <div className="dividas-toolbar">
        <button className="btn-primary" onClick={() => setShowForm(!showForm)}>
          {showForm ? '✕ Cancelar' : '+ Adicionar Dívida/Processo'}
        </button>
        <button className="btn-secondary" onClick={() => setShowCategorias(!showCategorias)}>
          {showCategorias ? '✕ Fechar Categorias' : '⚙️ Gerenciar Categorias'}
        </button>
      </div>

      {showCategorias && (
        <div className="form-card">
          <h2 className="form-card-title">Categorias</h2>
          <form onSubmit={handleAddCategoria} className="categoria-add-row">
            <input type="text" value={novaCategoria} onChange={(e) => setNovaCategoria(e.target.value)} placeholder="Ex: Banco, Carro, Cartão..." />
            <button type="submit" className="btn-primary">Adicionar</button>
          </form>
          <div className="categoria-list">
            {categorias.length === 0 && <p className="empty-hint">Nenhuma categoria cadastrada ainda.</p>}
            {categorias.map(c => (
              <span key={c.id} className="categoria-chip">
                {c.nome}
                <button type="button" onClick={() => handleDeletarCategoria(c.id)}>✕</button>
              </span>
            ))}
          </div>
        </div>
      )}

      {showForm && (
        <form onSubmit={handleAddOuEditar} className="form-card">
          <div className="form-row">
            <div className="form-group">
              <label>Tipo</label>
              <select value={formData.tipo} onChange={(e) => setFormData({...formData, tipo: e.target.value})}>
                <option value="divida">Dívida</option>
                <option value="processo">Processo Jurídico</option>
              </select>
            </div>
            <div className="form-group">
              <label>Categoria</label>
              <select value={formData.categoriaDividaId} onChange={(e) => setFormData({...formData, categoriaDividaId: e.target.value})}>
                <option value="">Selecionar</option>
                {categorias.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
              </select>
            </div>
          </div>

          <div className="form-group">
            <label>Nome</label>
            <input type="text" value={formData.nome} onChange={(e) => setFormData({...formData, nome: e.target.value})} placeholder={formData.tipo === 'processo' ? 'Ex: Ação Trabalhista X' : 'Ex: Financiamento Carro'} required />
          </div>

          {formData.tipo === 'processo' && (
            <div className="form-group">
              <label>Número do Processo</label>
              <input type="text" value={formData.numero_processo} onChange={(e) => setFormData({...formData, numero_processo: e.target.value})} placeholder="Ex: 0001234-56.2026.8.26.0100" />
            </div>
          )}

          <div className="form-row">
            <div className="form-group">
              <label>{formData.tipo === 'processo' ? 'Valor Atual (R$)' : 'Valor (R$)'}</label>
              <input type="number" value={formData.valor} onChange={(e) => setFormData({...formData, valor: e.target.value})} step="0.01" required />
            </div>
            {formData.tipo === 'divida' && (
              <div className="form-group">
                <label>Taxa de Juros (% a.m.)</label>
                <input type="number" value={formData.taxa_juros} onChange={(e) => setFormData({...formData, taxa_juros: e.target.value})} step="0.01" />
              </div>
            )}
          </div>

          {formData.tipo === 'divida' && (
            <div className="form-group">
              <label>Prazo (número de parcelas)</label>
              <input type="number" value={formData.prazo_meses} onChange={(e) => setFormData({...formData, prazo_meses: e.target.value})} min="1" />
            </div>
          )}

          <div className="form-buttons">
            <button type="submit" className="btn-primary">{editingId ? 'Atualizar' : 'Adicionar'}</button>
            <button type="button" className="btn-secondary" onClick={handleCancelar}>Cancelar</button>
          </div>
        </form>
      )}

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Nome</th>
              <th>Categoria</th>
              <th>Tipo</th>
              <th>Saldo Atual</th>
              <th>Parcela</th>
              <th>Parcelas</th>
              <th>Juros Total</th>
              <th>Status</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {dividas.map(d => (
              <React.Fragment key={d.id}>
                <tr>
                  <td>
                    {d.nome}
                    {d.tipo === 'processo' && d.numero_processo && <div className="processo-numero">{d.numero_processo}</div>}
                  </td>
                  <td>{d.CategoriaDivida?.nome || '—'}</td>
                  <td><span className={`type-badge ${d.tipo}`}>{d.tipo === 'processo' ? 'Processo' : 'Dívida'}</span></td>
                  <td>R$ {parseFloat(d.valor).toLocaleString('pt-BR', {minimumFractionDigits: 2})}</td>
                  <td>{d.prazo_meses ? `R$ ${d.valor_parcela.toLocaleString('pt-BR', {minimumFractionDigits: 2})}` : '—'}</td>
                  <td>{d.prazo_meses ? `${d.parcelas_pagas}/${d.prazo_meses}` : '—'}</td>
                  <td>{d.prazo_meses ? `R$ ${d.juros_total.toLocaleString('pt-BR', {minimumFractionDigits: 2})}` : '—'}</td>
                  <td><span className={`status ${d.status}`}>{d.status === 'ativa' ? 'Ativa' : 'Paga'}</span></td>
                  <td className="acoes-cell">
                    <button type="button" className="btn-small" onClick={() => handleEditar(d)}>✏️</button>
                    <button type="button" className="btn-small danger" onClick={() => handleDeletar(d.id)}>🗑️</button>
                    {d.tipo === 'divida' && d.prazo_meses && d.status === 'ativa' && (
                      <button type="button" className="btn-small info" onClick={() => abrirAntecipar(d)}>⏩ Antecipar</button>
                    )}
                    {d.tipo === 'processo' && (
                      <>
                        <button type="button" className="btn-small info" onClick={() => abrirAtualizarValor(d)}>💲 Atualizar</button>
                        <button type="button" className="btn-small" onClick={() => abrirHistorico(d)}>📜 Histórico</button>
                      </>
                    )}
                  </td>
                </tr>

                {acaoAberta && acaoAberta.id === d.id && acaoAberta.tipo === 'antecipar' && (
                  <tr className="acao-row">
                    <td colSpan="9">
                      <div className="acao-painel">
                        <strong>Antecipar parcelas de "{d.nome}"</strong>
                        <div className="acao-form-row">
                          <label>Nº de parcelas a antecipar (restam {d.parcelas_restantes})</label>
                          <input type="number" min="1" max={d.parcelas_restantes} value={antecipacaoForm.num_parcelas} onChange={(e) => setAntecipacaoForm({...antecipacaoForm, num_parcelas: e.target.value})} />
                          <label>Desconto (R$)</label>
                          <input type="number" step="0.01" value={antecipacaoForm.desconto} onChange={(e) => setAntecipacaoForm({...antecipacaoForm, desconto: e.target.value})} placeholder="0,00" />
                          <button type="button" className="btn-primary" onClick={() => handleConfirmarAntecipacao(d.id)}>Confirmar</button>
                          <button type="button" className="btn-secondary" onClick={() => setAcaoAberta(null)}>Cancelar</button>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}

                {acaoAberta && acaoAberta.id === d.id && acaoAberta.tipo === 'atualizar' && (
                  <tr className="acao-row">
                    <td colSpan="9">
                      <div className="acao-painel">
                        <strong>Atualizar valor de "{d.nome}"</strong>
                        <div className="acao-form-row">
                          <label>Novo valor (R$)</label>
                          <input type="number" step="0.01" value={atualizarForm.valor} onChange={(e) => setAtualizarForm({...atualizarForm, valor: e.target.value})} />
                          <label>Observação</label>
                          <input type="text" value={atualizarForm.observacao} onChange={(e) => setAtualizarForm({...atualizarForm, observacao: e.target.value})} placeholder="Ex: Atualização monetária" />
                          <button type="button" className="btn-primary" onClick={() => handleConfirmarAtualizacao(d.id)}>Confirmar</button>
                          <button type="button" className="btn-secondary" onClick={() => setAcaoAberta(null)}>Cancelar</button>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}

                {acaoAberta && acaoAberta.id === d.id && acaoAberta.tipo === 'historico' && (
                  <tr className="acao-row">
                    <td colSpan="9">
                      <div className="acao-painel">
                        <strong>Histórico de valores — "{d.nome}"</strong>
                        {historico.length === 0 && <p className="empty-hint">Nenhuma atualização registrada ainda.</p>}
                        {historico.map(h => (
                          <div key={h.id} className="historico-item">
                            <span>{new Date(h.data).toLocaleDateString('pt-BR', { timeZone: 'UTC' })}</span>
                            <span>R$ {parseFloat(h.valor).toLocaleString('pt-BR', {minimumFractionDigits: 2})}</span>
                            <span>{h.observacao || ''}</span>
                          </div>
                        ))}
                        <button type="button" className="btn-secondary" onClick={() => setAcaoAberta(null)}>Fechar</button>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
